export default __webpack_public_path__ + "static/media/GrowthInCommunity.93978027.png";